import {
  DirectionTool
} from "./chunk-NF5KRZJ4.mjs";
import {
  ColorModeTool
} from "./chunk-65GTWWLZ.mjs";
import {
  ADDON_ID,
  COLOR_MODE_TOOL_ID,
  DIRECTION_TOOL_ID
} from "./chunk-QUP5TB6E.mjs";

// src/manager.ts
import { addons, types } from "@storybook/manager-api";
addons.register(ADDON_ID, () => {
  const match = ({ viewMode }) => Boolean(viewMode && viewMode.match(/^(story|docs)$/));
  addons.add(DIRECTION_TOOL_ID, {
    type: types.TOOL,
    title: "Direction",
    render: DirectionTool,
    match
  });
  addons.add(COLOR_MODE_TOOL_ID, {
    type: types.TOOL,
    title: "Color Mode",
    render: ColorModeTool,
    match
  });
});
